import { SettingsAPI } from './api/SettingsAPI';
import { AppDispatch } from '../store.model';
import { actionsFeatureToggle } from '../featureToggle/slice/featureToggleSlice';

export const saveSettings =
  (settings: {
    applicationDefault?: string;
    temperatureUnitPreferred?: string;
  }) =>
  async (dispatch: AppDispatch) => {
    await dispatch(
      SettingsAPI.endpoints.setManySettings.initiate({
        settings,
      })
    ).unwrap();
  };

export const getSavedFeatureToggles = () => async (dispatch: AppDispatch) => {
  const savedConfiguration = await dispatch(
    SettingsAPI.endpoints.getAllSettings.initiate()
  ).unwrap();
  // we can override featureToggles with saved settings at the moment there not collisions
  await dispatch(actionsFeatureToggle.updateToggles(savedConfiguration));
};
